import { useContentsContext } from "./useContentsContext.hook";
import { CATEGORIES } from "../../../crud/helpers/routes";
import { handleResponse, getParams } from "../../../crud/helpers/validate";
import notice from "../../../utils/notice";

export const useCategories = () => {
  const { setAllCategories } = useContentsContext();

  const getCategories = () => {
    fetch(`${CATEGORIES}`, getParams("GET"))
      .then((res) => handleResponse(res))
      .then((json) => {
        const categoriesResponse = json?.items || [];
        setAllCategories(categoriesResponse);
      })
      .catch((e) => {
        notice("Error on loading categories ");
        console.error(e.errors);
      });
  };

  return { getCategories };
};
